import axios from 'axios'
import router from '../../router/index'

//console.log(process.env.VUE_APP_BASE_URL);
//console.log(process.env.VITE_SERVICE_BASE_URL);
const _axios = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL, //基础请求地址
    //basepicURL: 'http://testapi.hi-wooya.com', //基础请求地址
    //baseURL: 'http://223.112.20.74:9005/api', //基础请求地址
    //basepicURL: 'http://223.112.20.74:9003', //基础请求地址
    //baseURL: 'http://localhost:3000/api', //基础请求地址
    timeout: 30000, //最大请求时间
})



// 请求拦截器
_axios.interceptors.request.use(
    (config) => {
        let data = JSON.parse(sessionStorage.getItem('user'));
        if (data == null) {
            data = '';
        } else {
            data = data.token;
        }
        // if (data) {
        config.headers["Authorization"] = data;
        // }
        // console.log(config,  '59678974-0');
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
_axios.interceptors.response.use(
    (response) => {
        // const res = response.data;
        // console.log(response, '56-8947u-4');
        // 对响应数据做点什么，比如统一处理错误码
        // if (res.code !== 200) {
        // 假设服务器返回的数据结构中有code字段表示状态码
        // 这里可以根据实际后端接口返回的结构进行调整
        // alert(`Error: ${res.message}`);
        // return Promise.reject(new Error(res.message));
        // console.log(res, 'requestjs');    
        // }
        return response; // 返回实际数据
    },
    (error) => {
        // console.log(error, 'error')
        if (error.response && error.response.data.code == 401) {
            window.location.href = "/";
        }
        // 对响应错误做点什么，比如显示错误提示
        return Promise.reject(error);
    }
);

const http = {
    async get(url = '', params = {}) {
        let res = await _axios({
            url,
            data: params,
            method: 'GET'
        })
        return res.data;
    },
    async delete(url = '', params = {}) {
        let res = await _axios({
            url,
            data: params,
            method: 'delete'
        })
        return res.data;
    },
    async post(url = '', params = {}) {
        let res = await _axios({
            url,
            data: params,
            method: 'POST',
        })
        return res.data;
    },
    async post1(url = '', params = {}) {
        let res = await _axios({
            url,
            data: params,
            method: 'POST',
            responseType: 'blob', // 关键配置
            // headers: {'Content-Type': 'application/octet-stream'},
        })
        return res.data;
    },
    async postimg(url = '', params = {}) {
        let res = await _axios({
            url,
            data: params,
            headers: { 'Content-Type': 'multipart/form-data' },
            method: 'POST'
        })
        return res.data;
    },
    //     async get(url = '', params = {}) {
    //         let res = await _axios({
    //             url,
    //             data: params,
    //             headers: { 'Authorization': data },
    //             method: 'GET'
    //         }).catch(error => {
    //             // console.log(error, '55555');
    //             // 处理错误情况
    //             // if (error.message == 'Request failed with status code 401') {
    //             //     location.reload();
    //             //     window.location.href = '/'
    //             // }
    //             if (error.response.data.code == 401) {
    //                 location.reload();
    //                 window.location.href = '/'
    //             }
    //             return Promise.reject(error);
    //         });
    //         return res.data;
    //     },
    //     async delete(url = '', params = {}) {
    //         let res = await _axios({
    //             url,
    //             headers: { 'Authorization': data },
    //             method: 'delete'
    //         }).catch(error => {
    //             // console.log(error, '55555');
    //             // 处理错误情况
    //             if (error.response.data.code == 401) {
    //                 location.reload();
    //                 window.location.href = '/'
    //             }
    //             return Promise.reject(error);
    //         });
    //         return res.data;
    //     },
    //     async post(url = '', params = {}) {
    //         let res = await _axios({
    //             url,
    //             data: params,
    //             headers: { 'Authorization': data },
    //             method: 'POST'
    //         }).catch(error => {
    //             // console.log(error, '55555');
    //             // 处理错误情况
    //             if (error.response.data.code == 401) {
    //                 location.reload();
    //                 window.location.href = '/'
    //             }
    //             return Promise.reject(error);
    //         });
    //         return res.data;
    //     },
    //     async postimg(url = '', params = {}) {
    //         let res = await _axios({
    //             url,
    //             data: params,
    //             headers: { 'Authorization': data.token || null, 'Content-Type': 'multipart/form-data' },
    //             method: 'POST'
    //         }).catch(error => {
    //             // console.log(error, '55555');
    //             // 处理错误情况
    //             if (error.response.data.code == 401) {
    //                 location.reload();
    //                 window.location.href = '/'
    //             }
    //             return Promise.reject(error);
    //         });
    //         return res.data;
    //     }
}

export default http